import React, {Component} from 'react';
import msparcs from "assets/img/innoTerminal.png";
import sale from "../assets/img/sale.png";
import emi from "../assets/img/Emi.png";
import upi from "../assets/img/UPI.png";
import support from "../assets/img/support.png";
import lts from "../assets/img/LTS.png";
import summary from "../assets/img/summary.png";
import dip from "../assets/img/Dip.png";
import tap from "../assets/img/Tap.png";
import swipe from "../assets/img/swipe.png";
import axios from "axios";
import config from "react-global-configuration";
import {Button, Input, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {css} from "@emotion/core";

import slide1 from "../assets/img/slide-01.jpg";
import slide2 from "../assets/img/slide-02.jpg";
import slide3 from "../assets/img/slide-03.jpg";

import WebLogger from "../diyComponents/WebLogger";
import moment from "moment";
import ModalD from 'react-awesome-modal';

import qrImg from "../assets/img/qr-scan.gif";
require('../assets/css/main-style.css');

class TerminalSimulator extends Component {
    constructor(props) {
        super(props);
        this.state={
            invoiceNo: '',
            getInvoiceDetails: [],
            paidAmount: '',
            cardType: '',
            pinCode: '',
            mobile: '',
            logs: '',
            configModal: false,
            stores: [],
            selectedStoreCode: '',
            selectedUTIDCode: '',
            modes: [{key: 'N', value: 'Bill Number Entry Mode'},
                {key: 'L', value: 'Bill List Mode'},
                {key: 'S', value: 'Single EDC Mode'}],
            loading: false,
            getLModeInvoiceDetails: [],
            paymentComeFrom: '',
            selectedUserMode: '',
            invoiceDate: '',
            selectedStoreCurrentMode: '',
            AddClassName: 'pcodeB diyWebLoggerScrol  p-5 p-t-0 diyWebLogMarginTop5',
            txnMode: '',
            txnBy: '',
            transModeComeFrom: '',
            ETFUPIMode: ''
        }
    }

    componentDidMount() {
        document.getElementById("homeScreen").style.display = 'block';
        document.getElementById("startNMode").style.display = 'none';
        document.getElementById("itemList").style.display = 'none';
        document.getElementById('txnMode').style.display = 'none';
        document.getElementById('QRCode').style.display = 'none';
        //document.getElementById('qrImg').style.display = 'none';
        document.getElementById("paymentList").style.display = 'none';
        document.getElementById('enterPinCode').style.display = 'none';
        document.getElementById('paymentStatus').style.display = 'none';

        this.isValidIntegrationKey();
        this.getStore();
    }

    updateSimulatorConfig(e) {
        var selectedMode = e.target.value;
        if (selectedMode === "Select...") {
            return false;
        }

        this.setState({
            selectedUserMode: selectedMode
        })

        this.updateLogs(this.state.selectedUserMode === 'L' ? 'Selected Mode: Bill List Mode' : this.state.selectedUserMode === 'S' ? 'Selected Mode: Single EDC Mode' : this.state.selectedUserMode === 'N' ? 'Selected Mode: Bill Number Entry Mode' : '');

    }

    getStore() {
        axios.post(config.get('API_URL') + '/diyusers/getStoreDetails',
            {
                userId: ` ${localStorage.userId}`
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                console.log(response);

                this.setState({
                    stores: response.data.stores
                })

                this.setState({
                    selectedStoreCode: this.state.stores[0].storeCode,
                    selectedUTIDCode: this.state.stores[0].utid
                })

                axios.post(config.get('API_URL') + '/diyusers/getSimulatorConfig', {
                        userId: ` ${localStorage.userId}`,
                        utid: this.state.selectedUTIDCode
                    },
                    {
                        headers: {
                            Authorization: ` ${localStorage.usertoken}`
                        }
                    })
                    .then(response => {
                        console.log('response.data.config.configData' + response.data.config.configData);

                        this.setState({
                            selectedUserMode: response.data.config.configData,
                            mobile: ''
                        })

                        this.setLocalStorageData();

                        //document.getElementById("userMode").value = this.state.selectedUserMode;

                    })
                    .catch(err => {
                        console.log(err)
                    });

            })
            .catch(err => {
                console.log(err)
            });
    }

    setLocalStorageData() {
        var vUtidCode = `${localStorage.selectedUTIDCode}`;
        if (vUtidCode !== "undefined") {
            this.setState({
                selectedUTIDCode: vUtidCode
            })

        }

        var vStoreCode = `${localStorage.selectedStoreCode}`;
        if (vStoreCode !== "undefined") {
            this.setState({
                selectedStoreCode: vStoreCode
            })
        }

        var vUserMode = `${localStorage.selectedUserMode}`;
        console.log('vUserMode' + vUserMode);

        if (vUserMode !== "undefined") {
            this.setState({
                selectedUserMode: vUserMode,
            })
        }
    }

    isValidIntegrationKey() {
        axios.post(config.get('API_URL') + '/diyusers/verify-expiryDate', {},
            {
                headers: {
                    Authorization: `${localStorage.usertoken}`
                }
            })
            .then(response => {
                try {
                    if (response.data.status == 'expired') {
                        this.props.handleClick("tr", 4, "Session Has been expired.");
                        setTimeout(function () {
                            localStorage.removeItem("usertoken");
                            window.location.href = "/";
                        }.bind(this), 1000);
                    } else {
                        console.log(response.data);
                    }
                } catch (err) {
                    console.log("expired check failed!");
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    updateLogs(logData) {
        var dateString = moment().format('DD-MM-YYYY HH:mm:ss.SSS ');
        logData = dateString + logData
        this.setState({
            logs: logData + '\n' + this.state.logs
        });
    }

    goBack(divId) {
        document.getElementById("homeScreen").style.display = 'none';
        document.getElementById("startNMode").style.display = 'none';
        document.getElementById("itemList").style.display = 'none';
        document.getElementById('txnMode').style.display = 'none';
        document.getElementById('QRCode').style.display = 'none';
        //document.getElementById('qrImg').style.display = 'none';
        document.getElementById("paymentList").style.display = 'none';
        document.getElementById('enterPinCode').style.display = 'none';
        document.getElementById('paymentStatus').style.display = 'none';
        document.getElementById(divId).style.display = 'block';

    }

    onChangeInvoice(e) {
        this.setState({
            invoiceNo: e.target.value
        });
    }

    onCloudClick() {

        this.setState({
            invoiceNo: '',
            paidAmount: '',
            pinCode: '',
            cardType: '',
            paymentComeFrom: '',
            getLModeInvoiceDetails: [],
            backDivId:'homeScreen'
        })

        this.updateLogs('Getting Invoices');
        if (this.state.selectedUserMode === "N") {
            document.getElementById("homeScreen").style.display = 'none';
            document.getElementById("startNMode").style.display = 'block';
        } else if (this.state.selectedUserMode === "S") {
            this.getSModeInvoices();
        } else if (this.state.selectedUserMode === "L") {
            this.getLModeInvoices();
        }
    }

    getSModeInvoices() {
        this.updateLogs('Getting S Mode Invoice');
        axios.post(config.get('API_URL') + '/diyusers/getInvoices', {
                utid: this.state.selectedUTIDCode,
                billInvoiceNo: "",
                filterDate: "",
                limit: ""
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {

                if (response.data.invoices !== undefined) {
                    this.updateLogs("No Invoices Available.");
                    this.setState({
                        getLModeInvoiceDetails: [response.data.invoices[0]]

                    })
                } else {
                    this.updateLogs("No Invoices Available.");
                    this.props.handleClick("tr", 3, "No Invoices Available.");
                    return false;
                }

                document.getElementById("homeScreen").style.display = 'none';
                document.getElementById("itemList").style.display = 'block';
                this.updateLogs(response.data.message);
            })
            .catch(err => {
                console.log(err)
            });
    }

    //by L list
    getLModeInvoices() {
        this.updateLogs('Getting L Mode Invoice');
        axios.post(config.get('API_URL') + '/diyusers/getInvoices', {
                utid: this.state.selectedUTIDCode,
                billInvoiceNo: "",
                filterDate: "",
                limit: ""
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                console.log('list data');
                console.log(response);
                if (response.data.invoices !== undefined) {
                    this.updateLogs("Invoices List Available.");
                    this.setState({
                        getLModeInvoiceDetails: response.data.invoices

                    })
                } else {
                    this.updateLogs("No Invoices Available.");
                    this.props.handleClick("tr", 3, "No Invoices Available.");
                    return false;
                }


                document.getElementById("homeScreen").style.display = 'none';
                document.getElementById("itemList").style.display = 'block';
                this.updateLogs(response.data.message);
            })
            .catch(err => {
                console.log(err)
            });
    }

    //by invoice number
    getInvoceForNMode(e) {

        this.updateLogs('Fetching invoice ' + this.state.invoiceNo + ' details.');

        if (this.state.invoiceNo === "") {
            this.props.handleClick("tr", 3, "Enter Bill Invoice Number.");
            return false;
        }

        this.setState({
            loading: true
        });

        axios.post(config.get('API_URL') + '/diyusers/getInvoices', {
                utid: this.state.selectedUTIDCode,
                billInvoiceNo: this.state.invoiceNo,
                filterDate: "",
                limit: ""
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {

                if (response.data.status === "ok") {
                    var txnMode=response.data.invoices[0].txnMode;
                    this.setState({
                        //Here paid Amount
                        paidAmount: response.data.invoices[0].invoiceAmount,
                        invoiceDate: response.data.invoices[0].invoiceDate,
                        txnMode: (response.data.invoices[0].txnMode === null) ? '' : response.data.invoices[0].txnMode,
                        transModeComeFrom:'startNMode',
                        invoiceNo:response.data.invoices[0].billInvoiceNo,
                        ETFUPIMode:''
                    });

                    if(txnMode === null || txnMode==="")
                    {
                        this.updateLogs('Select transaction mode for payment');
                        document.getElementById("startNMode").style.display = 'none';
                        document.getElementById("txnMode").style.display = 'block';
                    }
                    else if(txnMode==="00") {
                        this.updateLogs('Select card for payment');
                        document.getElementById("startNMode").style.display = 'none';
                        document.getElementById("paymentList").style.display = 'block';

                        this.setState({
                            txnBy:'EFT'
                        });
                    }
                    else if(txnMode==="86")
                    {
                        this.updateLogs('Scan QR code for payment');
                        document.getElementById("startNMode").style.display = 'none';
                        document.getElementById("QRCode").style.display = 'block';
                        this.setState({
                            txnBy:'UPI'
                        });
                    }
                    else if(txnMode==="")
                    {
                        this.updateLogs('Select transaction mode for payment');
                        document.getElementById("startNMode").style.display = 'none';
                        document.getElementById("txnMode").style.display = 'block';
                    }

                } else {
                    this.updateLogs(response.data.message);
                }
            })
            .catch(err => {
                console.log(err)
            });
    }

    onDIPClick() {
        this.setState({cardType: 'Insert'})
        this.updateLogs('Selected card type: Insert for payment');
    }

    onTAPClick() {
        this.setState({cardType: 'TAP'})
        this.updateLogs('Selected card type: Tap for payment');
    }

    onSwipeClick() {
        this.setState({cardType: 'Swipe'})
        this.updateLogs('Selected card type: Swipe for payment');
    }

    getCard() {
        if (this.state.cardType === '') {
            this.props.handleClick("tr", 3, "Select Card Type.");
            return false;
        }
        document.getElementById('paymentList').style.display = 'none';
        document.getElementById('enterPinCode').style.display = 'block';

    }

    onChangePincode(e) {
        if (isNaN(e.target.value)) {

        } else {
            this.setState({
                pinCode: e.target.value
            });
        }

    }

    onPaidClick() {

        if (this.state.pinCode === '' || this.state.pinCode.length < 6) {
            this.props.handleClick("tr", 3, "Please Enter Pin.");
            return false;
        }

        if (this.state.pinCode !=='123456') {
            this.onPaidClickInvalid();
            // this.props.handleClick("tr", 3, "Please Enter Valid Pin.");
            return false;
        }
        this.updateLogs('Pin verification process...');
        axios.post(config.get('API_URL') + '/diyusers/updateInvoiceStatus', {
                billInvoiceNo: this.state.invoiceNo,
                txnType: "00",
                paidAmount: this.state.paidAmount,
                actualTxnMode: this.state.txnMode,
                mobileNo: this.state.mobile,
                utid: this.state.selectedUTIDCode
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                console.log(response.data.message);
                this.updateLogs(response.data.message);
               // this.goBack('homeScreen');
            })

        this.updateLogs('Pin verification successful');

        //Entry Code for Report
        var today = moment().format('YYYY-MM-DD HH:mm:ss');
        var invoiceDate = moment(this.state.invoiceDate).format('YYYY-MM-DD HH:mm:ss');

        const reqData = {
            store_code: this.state.selectedStoreCode,
            //mode: this.state.selectedUserMode === 'L' ? 'List' : this.state.selectedUserMode === 'S' ? 'Single' : this.state.selectedUserMode === 'N' ? 'Invoice' : 'Invoice',
            mode: this.state.selectedUserMode === 'L' ? 'Bill List Mode' : this.state.selectedUserMode === 'S' ? 'Single EDC Mode' : this.state.selectedUserMode === 'N' ? 'Bill Number Entry Mode' : '',
            invoice_id: this.state.invoiceNo,
            invoice_posted_date: invoiceDate,
            pin_status: 'Correct',
            pin_entry_date: today,
            payment_status: 'Success',
            payment_update_date: today
        }

        axios.post(config.get('API_URL') + '/diyusers/addTransaction',
            reqData,
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                console.log('Payment Status');
                console.log(response);

            })
            .catch(err => {
                console.log(err)
            });


        this.setState({
            pinCode: '',
            cardType: '',
            paymentComeFrom: '',
            getLModeInvoiceDetails: []
        })

        document.getElementById('enterPinCode').style.display = 'none';
        document.getElementById('paymentStatus').style.display = 'block';

        setTimeout(() => {  this.goBack('homeScreen'); }, 8000);
    }

    onPaidClickInvalid() {

        if (this.state.pinCode === '') {
            this.props.handleClick("tr", 3, "Please Enter PIN.");
            return false;
        }

        if (this.state.pinCode.length < 4) {
            this.props.handleClick("tr", 3, "Please Enter PIN.");
            return false;
        }
        this.props.handleClick("tr", 3, "Invalid PIN entered.");
        this.updateLogs('Invalid PIN entered.');


        var today = moment().format('YYYY-MM-DD HH:mm:ss');
        var invoiceDate = moment(this.state.invoiceDate).format('YYYY-MM-DD HH:mm:ss');
        const reqData = {
            store_code: this.state.selectedStoreCode,
            mode: (this.state.selectedUserMode === 'L' ? 'List' : this.state.selectedUserMode === 'S' ? 'Single' : this.state.selectedUserMode === 'N' ? 'Invoice' : 'Invoice'),
            invoice_id: this.state.invoiceNo,
            invoice_posted_date: invoiceDate,
            pin_status: 'Incorrect',
            pin_entry_date: today,
            payment_status: 'Pending',
            payment_update_date: today
        }

        axios.post(config.get('API_URL') + '/diyusers/addTransaction',
            reqData
            ,
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                console.log('Payment Status');
                console.log(response);

            })
            .catch(err => {
                console.log(err)
            });
        document.getElementById('enterPinCode').style.display = 'none';
        document.getElementById('homeScreen').style.display = 'block';

    }

    toggleTC() {

        this.state.selectedStoreCurrentMode = this.state.selectedUserMode;
        this.setState({
            configModal: !this.state.configModal
        })

        document.getElementById("homeScreen").style.display = 'block';
        document.getElementById("startNMode").style.display = 'none';
        document.getElementById("itemList").style.display = 'none';
        document.getElementById("paymentList").style.display = 'none';
        document.getElementById('enterPinCode').style.display = 'none';
        document.getElementById('paymentStatus').style.display = 'none';


    }

    toggleTCValidation() {
        var storE = document.getElementById("store");
        var StoreText = storE.options[storE.selectedIndex].text;
        var VintMode = storE.options[storE.selectedIndex].value;

        if (StoreText === "Select...") {
            this.props.handleClick("tr", 3, "Select Store.");
            return false;
        }


        var utidE = document.getElementById("INTMode");
        var utidText = utidE.options[utidE.selectedIndex].text;
        var vUseMode = utidE.options[utidE.selectedIndex].value;

        if (utidText === "Select...") {
            this.props.handleClick("tr", 3, "Select Mode.");
            return false;
        }

        if (this.state.selectedStoreCurrentMode !== vUseMode) {
            axios.post(config.get('API_URL') + '/diyusers/updateSimulatorConfig', {
                    storeCode: StoreText,
                    intMode: vUseMode
                },
                {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                .then(response => {
                    console.log('Updated user mode Value:' + vUseMode);
                    console.log('Update Store Code Msg' + response.data.message);

                    this.setState({
                        selectedUserMode: vUseMode,
                        selectedStoreCode: StoreText,
                        selectedUTIDCode: VintMode,
                        configModal: !this.state.configModal
                    })

                    localStorage.setItem('selectedStoreCode', StoreText);
                    localStorage.setItem('selectedUTIDCode', VintMode);
                    localStorage.setItem('selectedUserMode', vUseMode);


                    //document.getElementById("userMode").value = vUseMode;

                    this.updateLogs(this.state.selectedUserMode === 'L' ? 'Selected Mode: Bill List Mode' : this.state.selectedUserMode === 'S' ? 'Selected Mode: Single EDC Mode' : this.state.selectedUserMode === 'N' ? 'Selected Mode: Bill Number Entry Mode' : '');

                    document.getElementById("homeScreen").style.display = 'block';
                    document.getElementById("startNMode").style.display = 'none';
                    document.getElementById("itemList").style.display = 'none';
                    document.getElementById('txnMode').style.display = 'none';
                    document.getElementById('QRCode').style.display = 'none';
                    //document.getElementById('qrImg').style.display = 'none';
                    document.getElementById("paymentList").style.display = 'none';
                    document.getElementById('enterPinCode').style.display = 'none';
                    document.getElementById('paymentStatus').style.display = 'none';

                })
                .catch(err => {
                    console.log(err)
                });
        } else if (this.state.selectedStoreCode !== StoreText) {
            this.setState({
                selectedUserMode: vUseMode,
                selectedStoreCode: StoreText,
                selectedUTIDCode: VintMode,
                configModal: !this.state.configModal
            })

            localStorage.setItem('selectedStoreCode', StoreText);
            localStorage.setItem('selectedUTIDCode', VintMode);
            localStorage.setItem('selectedUserMode', vUseMode);


            //document.getElementById("userMode").value = vUseMode;

            this.updateLogs("Store changed to " + StoreText);

            document.getElementById("homeScreen").style.display = 'block';
            document.getElementById("startNMode").style.display = 'none';
            document.getElementById("itemList").style.display = 'none';
            document.getElementById('txnMode').style.display = 'none';
            document.getElementById('QRCode').style.display = 'none';
            //document.getElementById('qrImg').style.display = 'none';
            document.getElementById("paymentList").style.display = 'none';
            document.getElementById('enterPinCode').style.display = 'none';
            document.getElementById('paymentStatus').style.display = 'none';
        }
    }

    OnStoreChange(e) {

        document.getElementById("INTMode").value = "Select...";

        if (e.target.value === "Select...") {
            return false;
        }

        /* this.setState({
             selectedStoreCode: e.target.selectedOptions[0].text,
             selectedUTIDCode: e.target.value
         })*/

        let UTIDCode = e.target.value;


        axios.post(config.get('API_URL') + '/diyusers/getSimulatorConfig', {
                utid: UTIDCode
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                console.log('pnc response.data.config.configData' + response.data.config.configData);
                console.log(response);
                document.getElementById("INTMode").value = response.data.config.configData;

                this.state.selectedStoreCurrentMode = response.data.config.configData;
            })
            .catch(err => {
                console.log(err)
            });


    }

    onInvoicelistClick = (invoiceNo, Amount, invoiceDate, txnMode) => {

        this.setState({
            invoiceNo: invoiceNo,
            paidAmount: Amount,
            transModeComeFrom: 'list',
            invoiceDate: invoiceDate,
            txnMode:txnMode,
            ETFUPIMode:''
        });

        if(txnMode==="00") {
            this.updateLogs('Select Card for payment');
            document.getElementById("itemList").style.display = 'none';
            document.getElementById("paymentList").style.display = 'block';

            this.setState({
                txnBy:'EFT'
            });
        }
        else if(txnMode==="86")
        {
            this.updateLogs('Scan QR code for payment');
            document.getElementById("itemList").style.display = 'none';
            document.getElementById("QRCode").style.display = 'block';

            this.setState({
                txnBy:'UPI'
            });

        }
        else if(txnMode==="")
        {
            this.updateLogs('Select transaction Mode for payment');
            document.getElementById("itemList").style.display = 'none';
            document.getElementById("txnMode").style.display = 'block';
        }

    }

    onMouseOverAddClass(){
        this.setState({
            AddClassName:"pcodeB diyWebLoggerScrol  p-5 p-t-0 diyWebLogMarginTop5 diyOnlyScroll"
        })
    }

    onMouseOutRemoveClass(){
        this.setState({
            AddClassName:"pcodeB diyWebLoggerScrol  p-5 p-t-0 diyWebLogMarginTop5 "
        })
    }

    onQRScan = () => {
        this.setState({
            cardType:'QR Scan'
        })

        //document.getElementById("qrImg").style.display = 'block';

        setTimeout(() => {
            //document.getElementById("qrImg").style.display = 'none';
            document.getElementById('QRCode').style.display = 'none';
            document.getElementById('paymentStatus').style.display = 'block';

        }, 3000);

        this.updateLogs('QR code verification process...');
        axios.post(config.get('API_URL') + '/diyusers/updateInvoiceStatus', {
                billInvoiceNo: this.state.invoiceNo,
                txnType: "00",
                paidAmount: this.state.paidAmount,
                actualTxnMode: this.state.txnMode,
                mobileNo: this.state.mobile,
                utid: this.state.selectedUTIDCode
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                console.log(response.data.message);
                this.updateLogs(response.data.message);
                const str = JSON.stringify(response.data);
                //alert(str);

            })

        this.updateLogs('QR verification successful');

        //Entry Code for Report
        var today = moment().format('YYYY-MM-DD HH:mm:ss');
        var invoiceDate = moment(this.state.invoiceDate).format('YYYY-MM-DD HH:mm:ss');

        const reqData = {
            store_code: this.state.selectedStoreCode,
            //mode: this.state.selectedUserMode === 'L' ? 'List' : this.state.selectedUserMode === 'S' ? 'Single' : this.state.selectedUserMode === 'N' ? 'Invoice' : 'Invoice',
            mode: this.state.selectedUserMode === 'L' ? 'Bill List Mode' : this.state.selectedUserMode === 'S' ? 'Single EDC Mode' : this.state.selectedUserMode === 'N' ? 'Bill Number Entry Mode' : '',
            invoice_id: this.state.invoiceNo,
            invoice_posted_date: invoiceDate,
            pin_status: 'QR Scan ',
            pin_entry_date: today,
            payment_status: 'Success',
            payment_update_date: today
        }

        axios.post(config.get('API_URL') + '/diyusers/addTransaction',
            reqData,
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                console.log('Payment Status');
                console.log(response);

            })
            .catch(err => {
                console.log(err)
            });

        setTimeout(() => {  this.goBack('homeScreen'); }, 6000);

        this.setState({
            pinCode: '',
            paymentComeFrom: '',
            getLModeInvoiceDetails: []
        })
    }

    onEFTClick(){
        this.setState({
            txnBy:'EFT',
            ETFUPIMode:'txnMode',
            txnMode: '00'
        });
        document.getElementById('txnMode').style.display='none';
        document.getElementById('paymentList').style.display='block';
    }

    onUPIClick(){
        this.setState({
            txnBy:'UPI',
            ETFUPIMode:'txnMode',
            txnMode: '86'
        });


        document.getElementById('txnMode').style.display='none';
        document.getElementById('QRCode').style.display='block';
    }

    render() {
        var bindStore = [];
        if (this.state.stores) {
            bindStore = this.state.stores.map(data => {
                if (data.utid === this.state.selectedUTIDCode) {
                    return <option selected value={data.utid}>{data.storeCode}</option>
                } else {
                    return <option value={data.utid}>{data.storeCode}</option>
                }
            })
        }

        const bindMode = this.state.modes.map(data => {
            if (data.key === this.state.selectedUserMode) {
                return <option selected value={data.key}>{data.value}</option>
            } else {
                return <option value={data.key}>{data.value}</option>
            }
        })

        var bindLMode = [];
            if (this.state.getLModeInvoiceDetails) {
            console.log(this.state.getLModeInvoiceDetails);
            bindLMode = this.state.getLModeInvoiceDetails.map((data,i) => {
                let txnMode = (data.txnMode === null) ? '' : data.txnMode
                let TagData=data.invoiceDetails;
                let displaytag1 = (TagData === null || TagData.displayTag1 === null) ? '-' : TagData.displayTag1
                let displaytag2 = (TagData === null || TagData.displayTag2 === null) ? '-' : TagData.displayTag2
                
                return (<a href="#" className="list-group-item diyCenterText" onClick={this.onInvoicelistClick.bind(this, data.billInvoiceNo, data.invoiceAmount, data.invoicePostedTime, txnMode)}>
                    {/*<img src="img/view-edit-APN.png" className="img-icon" alt=""/>*/}
                 <div className="col-md-12">
                     <label className="diylistColor pull-left diySemPeddingTop">  {displaytag1}</label>
                    <label className="diylistColor diySemPeddingTop">  {data.billInvoiceNo}</label>
                    <label className="diylistColor pull-right diySemPeddingTop">{data.invoiceAmount}</label>
                 </div>
                    <div className="col-md-12 diyPendingInvoceHeightMarginTop">
                    <label className=" pull-left ">  {moment(data.invoicePostedTime).format('DD-MM-YYYY HH:mm:ss')}</label>
                    {/*<label className=" ">{moment(data.invoicePostedTime).format('HH:mm:ss')}</label>*/}
                        <label className=" pull-right">  {displaytag2}</label>
                    </div>
                </a>)
            })
        }

        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="diyCard">
                                <div className="col-md-4 ">
                                    <div className="img-terminal">
                                        <img src={msparcs} className="img-responsive" alt=""/>
                                    </div>
                                    <div className="box-insider diyBackground">
                                        <div className="terminalWidthBody ">
                                            <div className="diyWhiteBack">

                                                <div id="homeScreen" className="store-other terminalWidth">
                                                    <div className=" title-card title-card-full m-0 p-0 container ">
                                                        <div className="col-xs-12">
                                                            <p>
                                                                User mode
                                                                is: {this.state.selectedUserMode === 'L' ? 'Bill List Mode' : this.state.selectedUserMode === 'S' ? 'Single EDC Mode' : this.state.selectedUserMode === 'N' ? 'Bill Number Mode' : ''}
                                                            </p>
                                                        </div>

                                                        <hr/>

                                                        <div className=" col-xs-4">
                                                            <a href="#" className="btn-block"
                                                               onClick={this.onCloudClick.bind(this)}>
                                                                <img src={sale} className="img-responsive"/>
                                                                <h4>CLOUD</h4>
                                                            </a>
                                                        </div>
                                                        <div className="col-xs-4 diyDimLogo">
                                                            <a href="#" className="btn-block">
                                                                <img src={lts} className="img-responsive" alt/>
                                                                <h4>LTS</h4>
                                                            </a>
                                                        </div>
                                                        <div className="col-xs-4 diyDimLogo">
                                                            <a href="#" className="btn-block">
                                                                <img src={summary} className="img-responsive" alt/>
                                                                <h4>SUMMARY</h4>
                                                            </a>
                                                        </div>
                                                        <div className=" col-xs-4 diyDimLogo">
                                                            <a href="#" className="btn-block">
                                                                <img src={support} className="img-responsive" alt/>
                                                                <h4>SUPPORT</h4>
                                                            </a>
                                                        </div>
                                                        <div className=" col-xs-4 diyDimLogo">
                                                            <a href="#" className="btn-block">
                                                                <img src={emi} className="img-responsive" alt/>
                                                                <h4>EMI</h4>
                                                            </a>
                                                        </div>
                                                        <div className=" col-xs-4 diyDimLogo">
                                                            <a href="#" className="btn-block">
                                                                <img src={upi} className="img-responsive" alt/>
                                                                <h4>UPI</h4>
                                                            </a>
                                                        </div>
                                                        {/*<div className=" col-xs-4 diyDimLogo">*/}
                                                        {/*    <a href="#" className="btn-block">*/}
                                                        {/*        <img src={reprint} className="img-responsive" alt/>*/}
                                                        {/*        <h4>PRINT</h4>*/}
                                                        {/*    </a>*/}
                                                        {/*</div>*/}
                                                        {/*<div className=" col-xs-4 diyDimLogo">*/}
                                                        {/*    <a href="#" className="btn-block">*/}
                                                        {/*        <img src={lvoid} className="img-responsive" alt/>*/}
                                                        {/*        <h4>VOID</h4>*/}
                                                        {/*    </a>*/}
                                                        {/*</div>*/}
                                                    </div>
                                                </div>

                                                <div id="startNMode" className="store-other terminalWidth">
                                                    <div className=" title-card title-card-full m-0 p-0 container ">
                                                        <div className="col-xs-12">
                                                            <p>
                                                                User Mode
                                                                is: {this.state.selectedUserMode === 'L' ? 'Bill List Mode' : this.state.selectedUserMode === 'S' ? 'Single EDC Mode' : this.state.selectedUserMode === 'N' ? 'Bill Number Entry Mode' : ''}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <hr/>
                                                    <div className="col-xs-12">
                                                        <label>Enter Bill Invoice Number.</label>
                                                    </div>
                                                    <div className="col-xs-12">
                                                        <Input placeholder="Bill Invoice Number" id="txtInvoiceNumber"
                                                               type="text"
                                                               className="form-control"
                                                               value={this.state.invoiceNo}
                                                               onChange={this.onChangeInvoice.bind(this)}
                                                               maxlength="10"/>
                                                    </div>
                                                    <div className="col-xs-12 diyCenterText">
                                                        <br/>

                                                        <button
                                                            type="submit" className="diyTerButton "
                                                            onClick={this.getInvoceForNMode.bind(this)}>Get Invoice
                                                        </button>
                                                        <br/>
                                                        <br/>

                                                        <a
                                                            className="goback pull-left"
                                                            onClick={this.goBack.bind(this, 'homeScreen')}>Back
                                                        </a>
                                                    </div>


                                                </div>

                                                <div id="itemList" className="store-other terminalWidth">
                                                    <div className=" title-card title-card-full m-0 p-0 container ">
                                                        <div className="col-xs-12">
                                                            <p>
                                                                <a href="#" title="Back"
                                                                   className="btn btn-default actionBtn diyBack"
                                                                   role="button" currentitem="false"> <span
                                                                    className="fa fa-arrow-left pull-left"
                                                                    aria-hidden="true"
                                                                    onClick={this.goBack.bind(this, 'homeScreen')}></span></a> Pending
                                                                Invoices

                                                            </p>
                                                        </div>
                                                    </div>
                                                    <hr/>
                                                    <div className=" card ">
                                                        <div className="list-group diyInvoceListScrol">
                                                            {bindLMode}

                                                        </div>


                                                    </div>

                                                </div>

                                                <div id="txnMode" className="store-other terminalWidth">
                                                    <div className=" title-card title-card-full m-0 p-0 container ">

                                                    <div className="col-xs-12">
                                                        <p> <center>
                                                            Select Type
                                                        </center>
                                                        </p>
                                                    </div>
                                                    <div className="col-xs-12 diyCenterText">
                                                        <br />
                                                        <hr />
                                                        <a href="#" title="EFT"
                                                           className="btn btn-default"
                                                           role="button" onClick={this.onEFTClick.bind(this)}>
                                                            EFT Sale
                                                        </a>
                                                    </div>

                                                    <div className="col-xs-12 diyCenterText">
                                                        <br />
                                                        <a href="#" title="UPI"
                                                           className="btn btn-default"
                                                           role="button" onClick={this.onUPIClick.bind(this)}>
                                                            UPI Sale
                                                        </a>
                                                    </div>

                                                        <div className="col-xs-12 diyCenterText">
                                                            <br />
                                                            <hr />
                                                            {
                                                                this.state.transModeComeFrom==='startNMode'?
                                                                    <a
                                                                        className="goback"
                                                                        onClick={this.goBack.bind(this, "startNMode")}>Cancel
                                                                    </a>
                                                                    :
                                                                    <a
                                                                        className="goback"
                                                                        onClick={this.goBack.bind(this, "itemList")}>Cancel
                                                                    </a>
                                                            }

                                                        </div>

                                                    </div>
                                                </div>

                                                <div id="QRCode" className="store-other terminalWidth">
                                                    <div className=" title-card title-card-full m-0 p-0 container ">
                                                        <div className="col-xs-12">
                                                        <p> <center>
                                                          UPI SALE
                                                        </center>
                                                        </p>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div id="qrImg" className="col-xs-12 diyCenterText">
                                                        <img src={qrImg} width="200"/>
                                                    </div>
                                                    <span className="col-xs-12 diyCenterText"> <b>
                                                    Amount: {this.state.paidAmount}
                                                    </b>
                                                    </span>
                                                    <div className="col-xs-12 diyCenterText">
                                                        <button
                                                            type="submit" className="diyTerButton"
                                                            onClick={this.onQRScan.bind(this)}>Scan
                                                        </button>
                                                    </div>
                                                    <div className="col-xs-12 diyCenterText">
                                                        <br />
                                                        <hr />
                                                        {
                                                                this.state.ETFUPIMode === 'txnMode' ? <a
                                                                        className="goback pull-left"
                                                                        onClick={this.goBack.bind(this, 'txnMode')}>Back
                                                                    </a>
                                                                    :
                                                                    this.state.transModeComeFrom === 'startNMode' ?
                                                                        <a
                                                                            className="goback pull-left"
                                                                            onClick={this.goBack.bind(this, 'startNMode')}>Back
                                                                        </a>
                                                                        :
                                                                        <a
                                                                            className="goback pull-left"
                                                                            onClick={this.goBack.bind(this, 'itemList')}>Back
                                                                        </a>
                                                            }

                                                    </div>
                                                </div>

                                                <div id="paymentList" className=" store-other terminalWidthBody">
                                                    <div className=" title-card title-card-full m-0 p-0 container ">
                                                        <div className="col-xs-12">
                                                            <p>
                                                                Amount : {this.state.paidAmount}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <hr/>
                                                    <div className="store-other terminalWidth ">
                                                        <div className="col-xs-4 slite-line">
                                                            <a href="#" className="btn-block"
                                                               onClick={this.onDIPClick.bind(this)}>
                                                                <img src={dip} className="img-responsive" alt=""/>
                                                                <h4>
                                                                    Insert
                                                                </h4>
                                                            </a>
                                                        </div>
                                                        <div className="col-xs-4 slite-line">
                                                            <a href="#" className="btn-block"
                                                               onClick={this.onTAPClick.bind(this)}>
                                                                <img src={tap} className="img-responsive" alt=""/>
                                                                <h4>
                                                                    TAP
                                                                </h4>
                                                            </a>
                                                        </div>
                                                        <div className="col-xs-4">
                                                            <a href="#" className="btn-block"
                                                               onClick={this.onSwipeClick.bind(this)}>
                                                                <img src={swipe} className="img-responsive" alt=""/>
                                                                <h4>
                                                                    SWIPE
                                                                </h4>
                                                            </a>
                                                        </div>
                                                        <div className="col-xs-12">
                                                            <label>{this.state.cardType !== '' ? "Selected type: " + this.state.cardType : ''}</label>
                                                        </div>
                                                        <div className="col-xs-12 diyCenterText">
                                                            <br/>
                                                            <button
                                                                type="submit" className="diyTerButton"
                                                                onClick={this.getCard.bind(this)}>Next
                                                            </button>
                                                            <br/>
                                                            <br/>
                                                            {
                                                                this.state.ETFUPIMode === 'txnMode' ? <a
                                                                        className="goback pull-left"
                                                                        onClick={this.goBack.bind(this, 'txnMode')}>Back
                                                                    </a>
                                                                    :
                                                                    this.state.transModeComeFrom === 'startNMode' ?
                                                                        <a
                                                                            className="goback pull-left"
                                                                            onClick={this.goBack.bind(this, 'startNMode')}>Back
                                                                        </a>
                                                                        :
                                                                    <a
                                                                        className="goback pull-left"
                                                                        onClick={this.goBack.bind(this, 'itemList')}>Back
                                                                    </a>
                                                            }

                                                        </div>
                                                    </div>
                                                </div>

                                                <div id="enterPinCode" className="store-other terminalWidth">
                                                    <div className=" title-card title-card-full m-0 p-0 container ">
                                                        <div className="col-xs-12">
                                                            <p>
                                                                Amount : {this.state.paidAmount}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <hr/>
                                                    <div className="col-xs-12">
                                                        <label>Please Enter PIN.</label>
                                                    </div>
                                                    <div className="col-xs-12">
                                                        <Input placeholder="" id="pinCode" type="password"
                                                               className="form-control"
                                                               value={this.state.pinCode}
                                                               onChange={this.onChangePincode.bind(this)}
                                                               maxlength="6"/>
                                                    </div>


                                                    <div className="col-xs-12 diyCenterText">

                                                        <button
                                                            type="submit" className="diyTerButton"
                                                            onClick={this.onPaidClick.bind(this)}>OK
                                                        </button>
                                                        {' '}
                                                        {/*<button*/}
                                                        {/*    type="submit" className="diyTerButton"*/}
                                                        {/*    onClick={this.onPaidClickInvalid.bind(this)}>Invalid PIN*/}
                                                        {/*</button>*/}
                                                        <br />
                                                        <br />
                                                        <label>Valid pin is: </label>123456
                                                        <br/>
                                                        <br/>
                                                        <a
                                                            className="goback pull-left"
                                                            onClick={this.goBack.bind(this, 'paymentList')}>Back
                                                        </a>
                                                    </div>
                                                </div>

                                                <div id="paymentStatus" className="store-other terminalWidth">
                                                    <div className=" title-card title-card-full m-0 p-0 container ">
                                                        <div className="col-xs-12">
                                                            <p>
                                                                Payment Details
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <hr/>

                                                    <div className="col-xs-12">
                                                        <label>Payment Status:<b>&nbsp;Success</b> </label>
                                                    </div>

                                                    {/*<div className="col-xs-12">
                                                        <label>Payment Mode:<b>&nbsp; Card</b></label>
                                                    </div>*/}
                                                    <div className="col-xs-12">
                                                        <label>Payment Mode: <b>&nbsp;{this.state.txnBy}</b></label>
                                                    </div>

                                                    <div className="col-xs-12">
                                                        <label>Amount:<b>&nbsp; {this.state.paidAmount}</b> </label>
                                                    </div>

                                                    <br/>
                                                    <br/>
                                                    <br/>
                                                    <a className="diyCursor"
                                                       onClick={this.goBack.bind(this, 'homeScreen')}> Home
                                                    </a>
                                                </div>

                                            </div>
                                            <br/>
                                            <section className="carousel-default diyMarginTop">
                                                <div id="carousel-default" className="carousel slide"
                                                     data-ride="carousel">

                                                    <div className="carousel-inner" role="listbox">
                                                        <div className="item active">
                                                            <img src={slide1} alt="First slide"/>
                                                        </div>
                                                        <div className="item">
                                                            <img src={slide2} alt="Second slide"/>
                                                        </div>
                                                        <div className="item ">
                                                            <img src={slide3} alt="Third slide"/>
                                                        </div>
                                                        <div className="item ">
                                                            <img src={slide1} alt="Forth slide"/>
                                                        </div>
                                                    </div>
                                                    <ol className="carousel-indicators">
                                                        <li data-target="#carousel-default" data-slide-to="0"
                                                            className="active"></li>
                                                        <li data-target="#carousel-default" data-slide-to="1"
                                                            className=""></li>
                                                        <li data-target="#carousel-default" data-slide-to="2"
                                                            className=""></li>
                                                        <li data-target="#carousel-default" data-slide-to="3"
                                                            className=""></li>
                                                    </ol>
                                                </div>
                                            </section>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 p-0">

                                    <div id="divDownload" className="diyWeblogger "  onMouseOver={this.onMouseOverAddClass.bind(this)} onMouseLeave={this.onMouseOutRemoveClass.bind(this)}>
                                        <div className="col-md-3 diyLogPeddingTop ">
                                            <label htmlFor="Utids">Terminal Logs: </label>
                                        </div>
                                        <div className="col-md-9 addIcon ">
                                            <label>Selected Store: <b>{this.state.selectedStoreCode} </b> </label>
                                            &nbsp;&nbsp;&nbsp;
                                            <label>Selected
                                                Mode: <b>{this.state.selectedUserMode === 'L' ? 'Bill List Mode' : this.state.selectedUserMode === 'S' ? 'Single EDC Mode' : this.state.selectedUserMode === 'N' ? 'Bill Number Mode' : ''} </b>
                                            </label>
                                            &nbsp;&nbsp;&nbsp;
                                            <a href="#" className="addButton" role="button"
                                               onClick={this.toggleTC.bind(this)}><span
                                                className="glyphicon glyphicon-cog" aria-hidden="true"></span> Configure</a>
                                            &nbsp;&nbsp;&nbsp;
                                        </div>
                                        <div className="clearfix"></div>

                                        <div className={this.state.AddClassName}>
                                            <pre>
                                            <code>
                                                {this.state.logs}
                                            </code>
                                            </pre>

                                        </div>
                                     </div>
                                    <hr/>
                                    <div className=" ">
                                        <WebLogger/>
                                    </div>
                                </div>


                                <ModalD visible={this.state.configModal} width="400" height="280" >
                                        <ModalHeader toggle={this.toggleTC.bind(this)}>Merchant/User Info</ModalHeader>

                                    <div className="col-md-12">
                                        <br />
                                        <div className="col-md-4  diyLogPeddingTop">
                                            <label htmlFor="Store ">Choose Store:</label>
                                        </div>
                                        <div className="col-md-8 p-0">
                                            <select id="store" name="store" className="form-control"
                                                    onChange={(e) => this.OnStoreChange(e)}>
                                                <option value="Select...">Select...</option>
                                                {bindStore}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <br />
                                        <div className="col-md-4  diyLogPeddingTop">
                                            <label htmlFor="Utids">Choose Mode:</label>
                                        </div>
                                        <div className="col-md-8 p-0">
                                            <select id="INTMode" name="INTMode" className="form-control">
                                                {/*onChange={(e) => this.updateSimulatorConfig(e)}>*/}
                                                <option value="Select...">Select...</option>
                                                {bindMode}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <br />
                                        <div className="col-md-4  ">
                                            <label>Selected UTID is:</label>
                                        </div>
                                        <div className="col-md-8 p-0">
                                            <b>
                                                {this.state.selectedUTIDCode}
                                            </b>
                                        </div>
                                    </div>

                                    <ModalFooter>
                                            <Button color="primary"
                                                    onClick={this.toggleTCValidation.bind(this)}>Save</Button>{' '}

                                            <Button color="secondary"
                                                    onClick={this.toggleTC.bind(this)}>Cancel</Button>
                                        </ModalFooter>
                                </ModalD>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TerminalSimulator;